import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {ORBIT_TAP} from '../../themes/css-global-classes';


interface TapHandlerProps {
  enabled: boolean;
  elementRef: any;
}

export class TapHandlerLogic {
    constructor(private _element: HTMLElement) {
        this._element.addEventListener('click', this._onClickHandler);
    }

    private _timeoutRef = null;

    private _onClickHandler = () => {
        if (this._timeoutRef) {
            return;
        }

        this._element.classList.add(ORBIT_TAP);
        this._timeoutRef = setTimeout(() => {
            this._element.classList.remove(ORBIT_TAP);
            this._timeoutRef = null;
        }, 150);

    };

    dispose() {
        if(this._timeoutRef) {
            clearTimeout(this._timeoutRef);
        }

        this._element.removeEventListener('click', this._onClickHandler);
    }

}


export class TapHandler extends OrbitComponent<TapHandlerProps> {


  render() {
    return (
        <>
          {this.props.children}
        </>
    )
  }


  private _tapHandlerLogic: TapHandlerLogic | null = null;

  componentDidMount() {
    super.componentDidMount();
    if(this.props.enabled) {
      this._tapHandlerLogic = new TapHandlerLogic(this.props.elementRef.current);
    }

  }

  componentWillUnmount() {
    super.componentWillUnmount();
    if(this._tapHandlerLogic) {
        this._tapHandlerLogic.dispose();
    }
  }


}
